{
  // based on https://zoebijl.github.io/apg-tooltip/
  class TooltipElement extends HTMLElement {
    connectedCallback() {
      this.trigger = this.querySelector('button')
      this.tooltipContent = this.querySelector('[role=tooltip]')

      if(!this.trigger || !this.tooltipContent){
        console.warn(`<tool-tip> not correctly configured.`, this)
      }

      const tooltipId ='tooltip-toggler-' + Math.random().toString(36).slice(2, 11);
      this.trigger.setAttribute('aria-labelledby', tooltipId)
      this.tooltipContent.id = tooltipId
      this.tooltipContent.style.display = "none"

      this.globalEscapeBound = this.globalEscape.bind(this)
      this.globalPointerDownBound = this.globalPointerDown.bind(this)
      this.bindEvents()
    }

    openTooltip() {
      this.showTooltip()
      this.attachGlobalListener()
    }

    closeTooltip() {
      this.hideTooltip()
      this.removeGlobalListener()
    }

    bindEvents() {
      this.addEventListener('mouseenter', this.openTooltip.bind(this))
      this.addEventListener('touchstart', this.openTooltip.bind(this))
      this.trigger.addEventListener('focus', this.openTooltip.bind(this))

      this.addEventListener('mouseleave', this.closeTooltip.bind(this))
      this.trigger.addEventListener('blur', this.closeTooltip.bind(this))
    }

    attachGlobalListener() {
      document.addEventListener('keydown', this.globalEscapeBound)
      document.addEventListener('pointerdown', this.globalPointerDownBound)
    }

    removeGlobalListener() {
      document.removeEventListener('keydown', this.globalEscapeBound)
      document.removeEventListener('pointerdown', this.globalPointerDownBound)
    }

    globalEscape(e) {
      if (e.key === 'Escape' || e.key === 'Esc'){
        this.closeTooltip()
      }
    }

    globalPointerDown(e) {
      if ([this, this.trigger, this.tooltipContent].includes(e.target)) {
        e.preventDefault()
      } else {
        this.closeTooltip()
        this.trigger.blur()
      }
    }

    showTooltip() {
      this.tooltipContent.style.display = ""
      setTimeout(() => {
        const bounds = this.tooltipContent.getBoundingClientRect();

        if (bounds.left < 0) {
          this.tooltipContent.classList.add('tooltip-push-right');
        }

        if (bounds.right > window.innerWidth) {
          this.tooltipContent.classList.add('tooltip-push-left');
        }
      }, 0);
    }

    hideTooltip() {
      this.tooltipContent.style.display = "none"
    }
  }

  customElements.define('tool-tip', TooltipElement)
}